/**
 * Quale costo al minuto mostrare nell'avviso voce. Con un prezzo esplicito
 * (GPT-Live: prezzo del profilo) si usa quello; altrimenti il listino Vapi
 * di useVoicePricing, come oggi.
 * @param {{ perMinuteEur?: number|null, pricing?: { enabled?: boolean, estimatedCostPerMinuteEur?: number } }} [input]
 * @returns {{ visible: boolean, cost: number }}
 */
export function resolveCostNotice({ perMinuteEur = null, pricing = { enabled: false, estimatedCostPerMinuteEur: 0 } } = {}) {
  if (perMinuteEur !== null && perMinuteEur !== undefined) {
    const cost = Number(perMinuteEur) || 0;
    return { visible: cost > 0, cost };
  }
  const cost = Number(pricing?.estimatedCostPerMinuteEur) || 0;
  return { visible: !!pricing?.enabled && cost > 0, cost };
}
